import Clock from "../../assets/icon/NewsIcons/NewsCalendarSmall";
import { Link } from "react-router-dom";
import { apiAsset } from "../../commons/inFormTypes";
export const truncate = (str, len) => {
    if (str?.length > len && str?.length > 0) {
      let new_str = str + " ";
      new_str = str?.substr(0, len);
      new_str = str?.substr(0, new_str.lastIndexOf(" "));
      new_str = new_str.length > 0 ? new_str : str?.substr(0, len);
      return new_str + "...";
    }
    return str;
  };
const PicNews = ({ image, title, secondTitle, time ,navLink,big }) => {
    console.log(image)
    return (
        <div className="relative w-full h-full rounded-md">
            <Link to={navLink || "#"} className="opacity-100 w-full h-full absolute rounded-md">
                <img 
                src={apiAsset+image}
                loading="lazy"
                 alt="تصویر" className="rounded-md w-full h-full" />
            </Link>

            <div className="absolute w-full h-full opacity-100 bg-gradient-to-t from-[#102d2e] to-[#0000]  via-[#ffffff1b]  rounded-md"></div>
            <div className="absolute w-full h-full opacity-100 rounded-md flex flex-col items-start justify-end">
            {/* <div className="mr-[10px] ml-5">
                    <Link to={navLink || "#"} className="text-nextColorLight font-IRANYekanBold text-[13px] hover:cursor-pointer">
                        {truncate(secondTitle,50)}
                       </Link>
                </div> */}
                <div className="mr-[10px] ml-5 mb-1">
                    {big ?
                    <Link to={navLink || "#"} className="text-white font-IRANYekanBold text-[21px] hover:cursor-pointer">
                        {truncate(title,80)}
                       </Link>
                    :
                    <Link to={navLink || "#"} className="text-white font-IRANYekanBold text-[17px] hover:cursor-pointer">
                        {truncate(title,80)}
                       </Link>
                     }
                </div>
                <div className="flex items-center justify-start mr-[10px] mb-[10px] mt-[2px]">
                    <div className="ml-1">
                        <Clock />
                    </div>
                    <div>
                        <p className="text-white font-IRANYekanNormal text-[10px]">{time}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PicNews;
